import Page00 from '../../../../Book/EbookEtape_2/PagesBook2/00';
import Page01 from '../../../../Book/EbookEtape_2/PagesBook2/01';
import Page02 from '../../../../Book/EbookEtape_2/PagesBook2/02';
import Page03 from '../../../../Book/EbookEtape_2/PagesBook2/03';
import Page04 from '../../../../Book/EbookEtape_2/PagesBook2/04';
import Page05 from '../../../../Book/EbookEtape_2/PagesBook2/05';
import Page06 from '../../../../Book/EbookEtape_2/PagesBook2/06';
import Page07 from '../../../../Book/EbookEtape_2/PagesBook2/07';
import Page08 from '../../../../Book/EbookEtape_2/PagesBook2/08';
import Page09 from '../../../../Book/EbookEtape_2/PagesBook2/09';
import Page10 from '../../../../Book/EbookEtape_2/PagesBook2/10';
import Page11 from '../../../../Book/EbookEtape_2/PagesBook2/11';
import Page12 from '../../../../Book/EbookEtape_2/PagesBook2/12';
import Page13 from '../../../../Book/EbookEtape_2/PagesBook2/13';
import Page14 from '../../../../Book/EbookEtape_2/PagesBook2/14';
import Page15 from '../../../../Book/EbookEtape_2/PagesBook2/15';
import Page16 from '../../../../Book/EbookEtape_2/PagesBook2/16';
import Page17 from '../../../../Book/EbookEtape_2/PagesBook2/17';
import Page18 from '../../../../Book/EbookEtape_2/PagesBook2/18';
import Page19 from '../../../../Book/EbookEtape_2/PagesBook2/19';
import Page20 from '../../../../Book/EbookEtape_2/PagesBook2/20';
import Page21 from '../../../../Book/EbookEtape_2/PagesBook2/21';
import Page22 from '../../../../Book/EbookEtape_2/PagesBook2/22';
import Page23 from '../../../../Book/EbookEtape_2/PagesBook2/23';
import Page23a1 from '../../../../Book/EbookEtape_2/PagesBook2/23a1';
import Page23a2 from '../../../../Book/EbookEtape_2/PagesBook2/23a2';
import Page24 from '../../../../Book/EbookEtape_2/PagesBook2/24';
import Page25 from '../../../../Book/EbookEtape_2/PagesBook2/25';
import Page26 from '../../../../Book/EbookEtape_2/PagesBook2/26';
import Page27 from '../../../../Book/EbookEtape_2/PagesBook2/27';
import Page28 from '../../../../Book/EbookEtape_2/PagesBook2/28';
import Page29 from '../../../../Book/EbookEtape_2/PagesBook2/29';
import Page30 from '../../../../Book/EbookEtape_2/PagesBook2/30';
import Page31 from '../../../../Book/EbookEtape_2/PagesBook2/31';
import Page32 from '../../../../Book/EbookEtape_2/PagesBook2/32';
import Page33 from '../../../../Book/EbookEtape_2/PagesBook2/33';
import Page35 from '../../../../Book/EbookEtape_2/PagesBook2/35';
import Page36 from '../../../../Book/EbookEtape_2/PagesBook2/36';
import Page37 from '../../../../Book/EbookEtape_2/PagesBook2/37';
import Page38 from '../../../../Book/EbookEtape_2/PagesBook2/38';
import Page39 from '../../../../Book/EbookEtape_2/PagesBook2/39';
import Page40 from '../../../../Book/EbookEtape_2/PagesBook2/40';

type StepContentProps = {
  readOnly: boolean;
};

const Step2Content = ({ readOnly }: StepContentProps) => (
  <>
    <Page00 />
    <Page01 />
    <Page02 />
    <Page03 />
    <Page04 readOnly={readOnly} />
    <Page05 />
    <Page06 />
    <Page07 />
    <Page08 />
    <Page09 />
    <Page10 />
    <Page11 />
    <Page12 />
    <Page13 />
    <Page14 />
    <Page15 />
    <Page16 readOnly={readOnly} />
    <Page17 />
    <Page18 readOnly={readOnly} />
    <Page19 readOnly={readOnly} />
    <Page20 readOnly={readOnly} />
    <Page21 readOnly={readOnly} />
    <Page22 readOnly={readOnly} />
    <Page23 />
    <Page23a1 readOnly={readOnly} />
    <Page23a2 readOnly={readOnly} />
    <Page24 readOnly={readOnly} />
    <Page25 readOnly={readOnly} />
    <Page26 />
    <Page27 />
    <Page28 />
    <Page29 readOnly={readOnly} />
    <Page30 readOnly={readOnly} />
    <Page31 />
    <Page32 />
    <Page33 readOnly={readOnly} />
    <Page35 readOnly={readOnly} />
    <Page36 readOnly={readOnly} />
    <Page37 />
    <Page38 />
    <Page39 />
    <Page40 readOnly={readOnly} />
  </>
);

export default Step2Content;
